<template>
  <ion-card>
    <ion-card-content>
      <v-autocomplete
        ref="autoComplete"
        v-model="version"
        :items="versions"
        label="Version"
      />
    </ion-card-content>

    <ion-card-footer>
      <ion-button 
        expand="full"
        :disabled="busy || !version"
        @click="save"
      >
        <ion-spinner v-if="busy" />
        <template v-else>
          Pin

          <template v-if="version">
            To {{ version }}
          </template>
        </template>
      </ion-button>
    </ion-card-footer>
  </ion-card>
</template>

<script>
import { modalController } from '@modus/ionic-vue'

import { mapGetters } from 'vuex'
import { VAutocomplete } from 'vuetify/lib'

import store from '../../state'
import router from '../../router'
import vuetify from '../../plugins/vuetify'

export default {
  components: {
    VAutocomplete
  },
  props: {
    vuetify: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      busy: false,
      version: null
    }
  },
  computed: {
    ...mapGetters([
      'getCommitsForProject'
    ]),
    commits() {
      return this.getCommitsForProject(1)
    },
    versions() {
      return this.commits.map(commit => commit.version)
    }
  },
  created() {
    // set manually in modal
    this.$store = store
    this.$vuetify = this.vuetify
    
    this.snapToLatest()
  },
  methods: {
    save() {
      const serialNumber = router.currentRoute.params.serialNumber
      const version = this.version

      this.busy = true

      this.$store.dispatch('pinToVersion', { serialNumber, version })
        .then(() => modalController.dismiss())
        .finally(() => this.busy = false)
    },
    snapToLatest() {
      this.version = this.versions[0]
    }
  },
}
</script>

<style scoped>
ion-card {
  margin:0;
}
</style>

<style>
.pin-to-version-modal .modal-wrapper {
  background:none;
}
</style>